// extracted by mini-css-extract-plugin
export default {"navSubMenuItemLogo":"_5QP1X"};